// extracted by mini-css-extract-plugin
module.exports = {"bannerBase":"Billboard_bannerBase__PyqOD","withCTA":"Billboard_withCTA__pz97l","bannerContent":"Billboard_bannerContent__Z33xd","bannerLink":"Billboard_bannerLink__zFAij"};